'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { PHONE_CALL_BOOKING__PERMISSIONS } from '@/backend/modules/phone-call-booking/permissions';
import { FadeUp } from '@/frontend/design-system/_marketing/animation/FadeUp';
import { MarginsLayout } from '@/frontend/design-system/_marketing/layouts/Margins';
import { Tabs } from '@/frontend/design-system/navigation/Tabs';
import { useAuth } from '@/frontend/hooks/useAuth';
import { PhoneCallBookingSection } from './_sections/BookPhoneCall';
import { PlannedPhoneCallsSection } from './_sections/PlannedPhoneCalls';
import { UpdateOrganizerAvailabilitySection } from './_sections/UpdateOrganizerAvailability';
import { PHONE_CALL_BOOKING_TABS } from './_types';
export type ClientData = {
  fullname: string;
  phoneNumber: string;
  message: string;
};
export default function BezplatnaKonsultacja() {
  const $ = _c(14);
  const {
    user
  } = useAuth();
  const [activeTab, setActiveTab] = useState(PHONE_CALL_BOOKING_TABS.BOOK_A_PHONE_CALL);
  let t0;
  if ($[0] !== activeTab || $[1] !== user) {
    t0 = user.hasPermissions([PHONE_CALL_BOOKING__PERMISSIONS.PHONE_CALL_BOOKING.MANAGE.ENABLED]) && <div className="flex justify-center"><Tabs tabs={Object.values(PHONE_CALL_BOOKING_TABS).map(_temp)} activeTab={activeTab} setActiveTab={tab_0 => setActiveTab(tab_0 as PHONE_CALL_BOOKING_TABS)} className="p-4 md:p-0" /></div>;
    $[0] = activeTab;
    $[1] = user;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== activeTab) {
    t1 = activeTab === PHONE_CALL_BOOKING_TABS.BOOK_A_PHONE_CALL && <PhoneCallBookingSection />;
    $[3] = activeTab;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== activeTab) {
    t2 = activeTab === PHONE_CALL_BOOKING_TABS.ADD_ORGANIZER_AVAILABILITY && <UpdateOrganizerAvailabilitySection />;
    $[5] = activeTab;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== activeTab) {
    t3 = activeTab === PHONE_CALL_BOOKING_TABS.PLANNED_PHONE_CALLS && <PlannedPhoneCallsSection />;
    $[7] = activeTab;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t0 || $[10] !== t1 || $[11] !== t2 || $[12] !== t3) {
    t4 = <MarginsLayout><FadeUp><main className="space-y-6">{t0}{t1}{t2}{t3}</main></FadeUp></MarginsLayout>;
    $[9] = t0;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
function _temp(tab) {
  return {
    label: tab
  };
}